import React from 'react'
import View from './KYCStatus.view'
import { KYCStatusProps } from './KYCStatus.types'
import { useUser } from 'core/logic/user'

export default function KYCStatusLogic(props: KYCStatusProps) {
  const { profile } = useUser()
  return <View status={profile?.kycStatus} />
}
